import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPosts, deletePost } from '../utils/storage';
import { getCurrentUser } from '../utils/auth';

export default function Home() {
  const [posts, setPosts] = useState([]);
  const [query, setQuery] = useState('');

  useEffect(() => {
    const user = getCurrentUser();
    if (!user) {
      setPosts([]);
      return;
    }
    function load() { setPosts(getPosts().filter(p => p.author === user.username)); }
    load();
    const onStorage = () => load();
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  async function onDelete(id) {
    if (!window.confirm('确定要删除这篇文章吗？')) return;
    const ok = deletePost(id);
    if (!ok) return alert('删除失败：没有权限或文章不存在');
    setPosts(getPosts().filter(p => p.author === getCurrentUser()?.username));
  }

  const filtered = posts.filter(p => {
    if (!query.trim()) return true;
    const q = query.toLowerCase();
    return (p.title || '').toLowerCase().includes(q) || (p.content || '').toLowerCase().includes(q);
  });

  return (
    <div className="container">
      <div className="hero">
        <h1>轻量博客</h1>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <input placeholder="搜索文章（按标题或内容）" value={query} onChange={e => setQuery(e.target.value)} style={{ padding: 8, borderRadius: 8, border: '1px solid #e6edf3', minWidth: 220 }} />
          <Link to="/new" className="btn">写文章</Link>
          <Link to="/archive" className="btn secondary">查看归档</Link>
        </div>
      </div>

      <ul className="post-list">
        {filtered.length === 0 && <li className="empty">暂无符合条件的文章</li>}
        {filtered.map(p => (
          <li key={p.id} className="post-item">
            <Link to={`/post/${p.id}`} className="post-title">{p.title}</Link>
            <p className="post-excerpt">{p.content.length > 140 ? p.content.slice(0, 140) + '…' : p.content}</p>
            <div className="post-actions">
              <Link to={`/post/${p.id}`} className="link">查看</Link>
              <button className="del" onClick={() => onDelete(p.id)}>删除</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
